(() => {
  const excludedSortValues = new Set(['price-ascending', 'price-descending']);

  function pruneSortOptions(root = document) {
    root.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        if (excludedSortValues.has(option.value)) option.remove();
      });
    });
  }

  function buildMobileSortBar(root = document) {
    pruneSortOptions(root);

    const facetsContainer = root.querySelector('.facets-container');
    if (!facetsContainer || facetsContainer.querySelector('.cb-mobile-sortbar')) return;

    const sourceSelect = root.querySelector('#SortBy');
    if (!sourceSelect) return;

    const bar = document.createElement('div');
    bar.className = 'cb-mobile-sortbar';
    bar.setAttribute('aria-label', 'Collection sorting');

    const control = document.createElement('div');
    control.className = 'cb-mobile-sortbar__control';

    const label = document.createElement('label');
    label.className = 'cb-mobile-sortbar__label';
    label.setAttribute('for', 'CBMobileSortBy');
    label.textContent = 'Sort designs';

    const selectWrap = document.createElement('div');
    selectWrap.className = 'cb-mobile-sortbar__select-wrap';

    const select = document.createElement('select');
    select.className = 'cb-mobile-sortbar__select';
    select.id = 'CBMobileSortBy';
    select.setAttribute('aria-label', 'Sort designs');
    select.innerHTML = sourceSelect.innerHTML;
    select.value = sourceSelect.value;

    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    selectWrap.appendChild(select);
    control.appendChild(label);
    control.appendChild(selectWrap);

    const count = document.createElement('span');
    count.className = 'cb-mobile-sortbar__count';
    const countSource = root.querySelector('.cb-collection-count');
    count.textContent = countSource ? countSource.textContent.trim() : '';

    bar.appendChild(control);
    bar.appendChild(count);
    facetsContainer.prepend(bar);

    const staleOpenFacet = facetsContainer.querySelector('.mobile-facets__disclosure[open]');
    if (staleOpenFacet) staleOpenFacet.removeAttribute('open');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => buildMobileSortBar(document), { once: true });
  } else {
    buildMobileSortBar(document);
  }

  document.addEventListener('shopify:section:load', (event) => buildMobileSortBar(event.target));
})();
